import { render } from "./StatisticsPortalViewsCountByTimeTab.vue?vue&type=template&id=3da6ece0&ts=true"
import script from "./StatisticsPortalViewsCountByTimeTab.vue?vue&type=script&lang=ts"
export * from "./StatisticsPortalViewsCountByTimeTab.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__